/**
 * `/market/purchases` — what this account bought, and the receipt for each (M4d).
 */
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/market/purchases')({});
